import React, { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { Loader2, Lock } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card, CardHeader, CardTitle, CardContent, Button, Input, Label, toast } from "@/components/ds";

export function ChangePasswordCard() {
  const { logout } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");

  const change = useMutation({
    mutationFn: () => api.changePassword(current, next),
    onSuccess: async () => {
      toast.success("Password changed. Please sign in again.");
      await logout();
    },
    onError: (e) => toast.error(formatApiError(e)),
  });

  const valid = current.length > 0 && next.length >= 8 && next === confirm;
  return (
    <Card data-testid="change-password-card">
      <CardHeader><CardTitle className="flex items-center gap-2"><Lock className="h-5 w-5 text-slate-500" /> Change password</CardTitle></CardHeader>
      <CardContent className="space-y-4">
        <div><Label>Current password</Label><Input type="password" data-testid="cp-current" value={current} onChange={(e) => setCurrent(e.target.value)} /></div>
        <div className="grid gap-3 sm:grid-cols-2">
          <div><Label>New password</Label><Input type="password" data-testid="cp-new" value={next} onChange={(e) => setNext(e.target.value)} /></div>
          <div><Label>Confirm new password</Label><Input type="password" data-testid="cp-confirm" value={confirm} onChange={(e) => setConfirm(e.target.value)} /></div>
        </div>
        {next.length > 0 && next.length < 8 && <p className="text-xs text-red-600">Password must be at least 8 characters.</p>}
        {confirm.length > 0 && next !== confirm && <p className="text-xs text-red-600">Passwords do not match.</p>}
        <p className="text-xs text-slate-500">Changing your password signs you out of all sessions for security.</p>
        <Button data-testid="cp-submit" disabled={!valid || change.isPending} onClick={() => change.mutate()}>
          {change.isPending && <Loader2 className="h-4 w-4 animate-spin" />} Change password
        </Button>
      </CardContent>
    </Card>
  );
}
